import { cn } from '@cobliteam/ui/utils';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { forwardRef } from 'react';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.CollapsibleContent>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>
>(({ children, className, ...props }, ref) => {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      {...props}
      ref={ref}
      className={cn('overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down motion-reduce:animate-none', className)}
    >
      {children}
    </CollapsiblePrimitive.CollapsibleContent>
  );
});

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
